import React from 'react';
import { Helmet } from 'react-helmet-async';
import { sendGAPageview } from '../utils/gaConsent';
import CommonHeader from '../components/Headers/CommonHeader';
import ActivationContent from '../components/AccountActivation/ActivationContent';
import $ from 'jquery';

export default function About() {
  $('.popover').hide();
  sendGAPageview({
    hitType: 'pageview',
    page: '/Activate',
    title: 'Account Activation',
  });

  return (
    <React.Fragment>
      <Helmet>
        <title>DISGENET: Account Activation</title>
        <meta name="description" content="Activate your DISGENET account." />
      </Helmet>
      <CommonHeader />
      <ActivationContent />
    </React.Fragment>
  );
}
